import Component from "@glimmer/component";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import destroyRecord from "glesys-controlpanel/utils/destroy-record";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class SidebarOrganizationProjectSwitcherSettings extends Component {
  @service router;
  @service intl;
  @service notification;
  @service store;

  get currentProject() {
    return this.args.currentProject;
  }

  renameTask = task(async (name) => {
    let project = this.currentProject;
    project.name = name;

    await this.store
      .request(saveRecord(project))
      .then(() => {})
      .catch((error) => {
        project.rollbackAttributes();
        throw error;
      });
  });

  setColorTask = task(async (color) => {
    let project = this.currentProject;
    project.color = color;

    await this.store
      .request(saveRecord(project))
      .then(() => {})
      .catch((error) => {
        project.rollbackAttributes();
        throw error;
      });
  });

  deleteTask = task(async () => {
    let project = this.args.currentProject;

    destroyRecord(project);

    this.notification.add(
      "success",
      this.intl.t("project.settings.delete-notification.title"),
      this.intl.t("project.settings.delete-notification.text"),
    );

    this.router.transitionTo("organization", { queryParams: { project: null } });
  });
}
